import { SidebarMenuItems } from './sidebar.model';
import { UserRole } from '@app/core/auth/user-role.enum';

export const MENU_CONFIG: SidebarMenuItems[] = [
  {
    title: 'Messstellenübersicht',
    icon: 'analytics',
    link: '/dashboard/measurement-location-overview',
    roles: [UserRole.MANAGER, UserRole.TECHNICIAN, UserRole.USER],
  },
  {
    title: 'Messstellen',
    icon: 'location_on',
    link: '/dashboard/measurement-location-management',
    roles: [UserRole.MANAGER, UserRole.TECHNICIAN, UserRole.USER],
  },
  {
    title: 'Geräte',
    icon: 'barcode_reader',
    link: '/dashboard/device-management',
    roles: [UserRole.MANAGER, UserRole.TECHNICIAN, UserRole.USER],
  },
  {
    title: 'Mandanten',
    icon: 'person',
    link: '/dashboard/tenant-management',
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    title: 'Benutzer',
    icon: 'groups',
    link: '/dashboard/user-management',
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
  },
];
